// PEBO

import { createTheme } from "@mui/material/styles";
// import amber from "@mui/material/colors/amber";
import green from "@mui/material/colors/orange";

export default createTheme({
  paper: {
    // RMW  Test
    tertiary: {
      ///hausify hellgrau f2f2f2
      main: "#F1F1F1",
      text: "#000",
    },
  },
  palette: {
    primary: {
      ///hausify blau 00a2c7
      main: "#52A625",
    },
    secondary: {
      ///hausify orange FCC332 (zb Head-Zeile Dropdown)
      // light
      // dark
      // FeSt Hausverwalt4
      main: "#52A625",
      contrastText: "#fff",
    },
    notification: {
      ticketBadge: {
        // The number configures the shade
        main: green[500],
        text: "#fff",
      },
    },
    importNotification: {
      main: "#52A625",
      text: "#fff",
    },
    ticketsNotification: {
      ///hausify orange FCC332 (zb Meine Verwaltung)
      main: "#52A625",
      text: "#fff",
    },
    estateNotification: {
      ///hausify rosa e3cfde
      main: "#52A625",
      contrastText: "#333",
    },
    postingsNotification: {
      ///hausify blau 00a2c7
      main: "#52A625",
      text: "#fff",
    },

    documentsNotification: {
      main: "#eee",
      contrastText: "#333333",
      text: "#333333",
    },
    explainerBox: {
      main: "#777",
    },
  },
  typography: {
    fontFamily: ["roboto", "sans-serif", "serif"].join(","),
  },
});
